module.exports = __webpack_public_path__ + "static/media/landing_sightseeing.4a82bb79.svg";